import { Directive, effect, ElementRef, inject, input, Renderer2 } from '@angular/core';
import { type FeatureToggleKeys, FeatureToggleService } from './feature-toggle.service';

@Directive({ selector: '[rcpRystyleToggle]' })
export class RestyleFeatureToggleDirective {
  rcpRystyleToggle = input<FeatureToggleKeys | undefined>();

  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);
  private featureToggle = inject(FeatureToggleService);

  constructor() {
    effect(() => {
      const clazz = this.rcpRystyleToggle();
      // @ts-expect-error TS2345 argument not assignable
      if (!this.featureToggle.getFeature(clazz)) {
        this.renderer.addClass(this.elementRef.nativeElement, `not-${clazz}`);
      }
    });
  }
}
